(function () {
  const containers = document.querySelectorAll("[id^='component_']");
  if (!containers) return;
  containers.forEach((component) => {
    const tables = component.querySelectorAll('table');
    if (tables.length === 0);
    tables.forEach((table) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('responsive-table');
      component.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  });
})();
